module.exports = __webpack_public_path__ + "img/empty-folder.e07513b8.svg";